<template>
  <div class="relative page-wrapper grid-lines">
    <!-- Glass Cubes Background -->
    <!-- <div class="cubes-container">
      <div class="cube-wrapper cube-1">
        <div class="cube">
          <div class="face front"></div>
          <div class="face back"></div>
          <div class="face right"></div>
          <div class="face left"></div>
          <div class="face top"></div>
          <div class="face bottom"></div>
        </div>
      </div>
      <div class="cube-wrapper cube-2">
        <div class="cube">
          <div class="face front"></div>
          <div class="face back"></div>
          <div class="face right"></div>
          <div class="face left"></div>
          <div class="face top"></div>
          <div class="face bottom"></div>
        </div>
      </div>
      <div class="cube-wrapper cube-3">
        <div class="cube">
          <div class="face front"></div>
          <div class="face back"></div>
          <div class="face right"></div>
          <div class="face left"></div>
          <div class="face top"></div>
          <div class="face bottom"></div>
        </div>
      </div>
      <div class="cube-wrapper cube-4">
        <div class="cube">
          <div class="face front"></div>
          <div class="face back"></div>
          <div class="face right"></div>
          <div class="face left"></div>
          <div class="face top"></div>
          <div class="face bottom"></div>
        </div>
      </div>
      <div class="cube-wrapper cube-5">
        <div class="cube">
          <div class="face front"></div>
          <div class="face back"></div>
          <div class="face right"></div>
          <div class="face left"></div>
          <div class="face top"></div>
          <div class="face bottom"></div>
        </div>
      </div>
      <div class="cube-wrapper cube-6">
        <div class="cube">
          <div class="face front"></div>
          <div class="face back"></div>
          <div class="face right"></div>
          <div class="face left"></div>
          <div class="face top"></div>
          <div class="face bottom"></div>
        </div>
      </div>
    </div> -->

    <div class="relative min-h-[600px] md:min-h-[700px]">
      <section class="max-w-6xl mx-auto px-4 pt-24 md:pt-28 relative z-10">
        <div class="flex flex-col md:flex-row md:items-center md:gap-8">
          <!-- Left side: Text content -->
          <div class="w-full md:w-1/2 fade-in-up">
            <h1
              class="text-6xl md:text-8xl font-bold tracking-tighter text-center md:text-left uppercase font-poppins text-gray-800"
              style="line-height: 0.9"
            >
              <span class="ai-glow">AI</span>
              Football Predictions made
              <span
                id="typewriter-header"
                class="glitch-text"
                data-text="Smarter"
              ></span>
            </h1>
            <h2
              class="text-xl mx-0.5 font-normal text-center md:text-left my-5 md:mx-0"
            >
              Make better football predictions using our
              <span class="font-extrabold">MatchView™</span> cards & AI
              football tips based on current data.
            </h2>
          </div>

          <!-- Right side: Card -->

          <transition name="fade-up">
            <div
              v-if="countdown"
              class="w-full md:w-1/2 flex flex-col items-center justify-center mt-10 md:mt-0"
            >
              <div
                v-if="countdown && countdown != 'Now!'"
                class="mx-auto md:mx-0 mb-3"
              >
                <div
                  class="text-center mb-2 text-xs uppercase tracking-wide text-gray-600 font-semibold"
                >
                  Next Match In
                </div>
                <div class="flex gap-1">
                  <div class="flip-digit-group">
                    <div class="flip-digit">
                      <span class="digit-top">{{
                        countdown.split(":")[0]
                      }}</span>
                    </div>
                    <div
                      class="text-[8px] text-gray-600 text-center mt-1 uppercase"
                    >
                      Days
                    </div>
                  </div>
                  <div class="flip-separator">:</div>
                  <div class="flip-digit-group">
                    <div class="flip-digit">
                      <span class="digit-top">{{
                        countdown.split(":")[1]
                      }}</span>
                    </div>
                    <div
                      class="text-[8px] text-gray-600 text-center mt-1 uppercase"
                    >
                      Hours
                    </div>
                  </div>
                  <div class="flip-separator">:</div>
                  <div class="flip-digit-group">
                    <div class="flip-digit">
                      <span class="digit-top">{{
                        countdown.split(":")[2]
                      }}</span>
                    </div>
                    <div
                      class="text-[8px] text-gray-600 text-center mt-1 uppercase"
                    >
                      Mins
                    </div>
                  </div>
                  <div class="flip-separator">:</div>
                  <div class="flip-digit-group">
                    <div class="flip-digit">
                      <span class="digit-top">{{
                        countdown.split(":")[3]
                      }}</span>
                    </div>
                    <div
                      class="text-[8px] text-gray-600 text-center mt-1 uppercase"
                    >
                      Secs
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="countdown == 'Now!'" class="mx-auto md:mx-0 mb-3">
                <div class="scoreboard-panel">
                  <span class="scoreboard-text uppercase">Match Started!</span>
                </div>
              </div>
              <Card
                mode="chrono"
                :match="nextMatch"
                :showOdds="true"
                v-if="nextMatch?.date"
                class="w-full mx-auto mb-10 md:my-4 !md:w-full !md:min-w-[450px] !md:h-[185px]"
              />
              <div
                class="flex flex-row gap-4 items-center justify-center mt-5 pb-8 md:pb-0"
              >
                <a
                  href="https://numbersgame.uk/signup/monthly"
                  class="block space-x-4"
                >
                  <router-link
                    :to="`/signup/${type}`"
                    class="btn-gradient shadow-xl inline-flex items-center justify-center text-xs p-3 px-6 font-bold uppercase lg:text-lg text-white"
                  >
                    Get Started
                  </router-link>
                </a>
              </div>
            </div>
          </transition>
        </div>
      </section>
    </div>
    <template v-if="nextMatch?.date">
      <div>
        <section class="max-w-6xl mx-auto px-4 py-4 md:py-12 relative">
          <div
            class="p-5 md:p-10 border rounded-2xl shadow-xl border-white/30 bg-white/30 backdrop-blur-sm"
          >
            <div class="md:flex items-center justify-center gap-10 md:gap-8">
              <div class="flex-1 text-left">
                <h2
                  class="uppercase font-poppins text-blue-700 mb-2 font-bold text-2xl drop-shadow-lg"
                >
                  Whats the Point? 🤔
                </h2>
                <p>
                  Most punters are making predictions on a whim because they
                  don't have access to the data they need.
                </p>
                <br />
                <p>
                  Those that <span class="italic font-bold">do</span> use data
                  are taking hours to do their research.
                </p>
                <br />
                <p>
                  <strong>Enter Numbers Game.</strong>
                </p>
                <br /><br />
                <span class="hidden md:inline">
                  <h2
                    class="font-poppins uppercase text-blue-700 mb-2 font-bold text-2xl drop-shadow-lg mb-5 text-center md:text-left"
                  >
                    What We Offer You 🚀
                  </h2>
                  <span class="flex mb-5">
                    <div
                      class="border rounded-3xl shadow-xl p-2 flex items-center"
                      style="height: fit-content; width: fit-content"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 13l4 4L19 7"
                          stroke="#34D399"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                      <div
                        class="flex-1 text-left text-sm"
                        style="line-height: 1.2"
                      >
                        <p class="p-2">
                          Everything you need to make data-backed football
                          predictions quicker, easier and have more fun whilst
                          doing it.
                        </p>
                      </div>
                    </div>
                  </span>
                  <span class="flex mb-5">
                    <div
                      class="border rounded-3xl shadow-xl gap-1 p-2 flex items-center"
                      style="height: fit-content; width: fit-content"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 13l4 4L19 7"
                          stroke="#34D399"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                      <div
                        class="flex-1 text-left text-sm"
                        style="line-height: 1.2"
                      >
                        <p class="p-2">
                          Accurate AI powered football predictions for
                          glanceable insights.
                        </p>
                      </div>
                    </div>
                  </span>
                  <span class="flex mb-5">
                    <div
                      class="border rounded-3xl shadow-xl gap-1 p-2 flex items-center"
                      style="height: fit-content; width: fit-content"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 13l4 4L19 7"
                          stroke="#34D399"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                      <div
                        class="flex-1 text-left text-sm"
                        style="line-height: 1.2"
                      >
                        <p class="p-2">
                          Over 50 leagues covered so you're clued up no matter
                          the competition.
                        </p>
                      </div>
                    </div>
                  </span>
                  <span class="flex mb-5">
                    <div
                      class="border rounded-3xl shadow-xl gap-1 p-2 flex items-center"
                      style="height: fit-content; width: fit-content"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 13l4 4L19 7"
                          stroke="#34D399"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                      <div
                        class="flex-1 text-left text-sm"
                        style="line-height: 1.2"
                      >
                        <p class="p-2">
                          A vibrant discord community with exclusive daily tips
                          from the team behind Numbers Game.
                        </p>
                      </div>
                    </div>
                  </span>
                </span>
              </div>
              <div class="blur-type-3" v-in-viewport="{ margin: '-50% 0px' }">
                <Card
                  mode="chrono"
                  :match="nextMatch"
                  :showOdds="true"
                  v-if="nextMatch?.date"
                  class="!w-full md:min-w-[385px] relative"
                  :extraBlurContent="true"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="md:hidden">
        <section class="max-w-6xl mx-auto px-4 py-4 md:py-12 relative">
          <div class="p-5 md:p-10 text-center">
            <h2
              class="uppercase font-poppins text-blue-700 mb-2 font-bold text-2xl drop-shadow-lg mb-5"
            >
              What We Offer You 🚀
            </h2>
            <span class="flex mb-5">
              <div
                class="border text-sm rounded-2xl shadow-xl bg-white/30"
                style="
                  height: fit-content;
                  width: fit-content;
                  line-height: 1.2;
                "
              >
                <div class="flex-1 md:text-left">
                  <p class="p-4">
                    Everything you need to make data-backed football predictions
                    quicker, easier and have more fun whilst doing it.
                  </p>
                </div>
              </div>
            </span>
            <span class="flex mb-5">
              <div
                class="border text-sm rounded-2xl shadow-xl bg-white/30"
                style="
                  height: fit-content;
                  width: fit-content;
                  line-height: 1.2;
                "
              >
                <div class="flex-1 md:text-left">
                  <p class="p-4">
                    Accurate AI powered football predictions for glanceable
                    insights.
                  </p>
                </div>
              </div>
            </span>
            <span class="flex mb-5">
              <div
                class="border text-sm rounded-2xl shadow-xl bg-white/30"
                style="
                  height: fit-content;
                  width: fit-content;
                  line-height: 1.2;
                "
              >
                <div class="flex-1 md:text-left">
                  <p class="p-4">
                    Over 50 leagues covered so you're clued up no matter the
                    competition.
                  </p>
                </div>
              </div>
            </span>
            <span class="flex mb-5">
              <div
                class="border text-sm rounded-2xl shadow-xl bg-white/30"
                style="
                  height: fit-content;
                  width: fit-content;
                  line-height: 1.2;
                "
              >
                <div class="flex-1 md:text-left">
                  <p class="p-4">
                    A vibrant discord community with exclusive daily tips from
                    the team behind Numbers Game.
                  </p>
                </div>
              </div>
            </span>
          </div>
        </section>
      </div>
      <div>
        <div class="">
          <section class="max-w-6xl mx-auto px-4 py-4 md:py-12 relative">
            <div
              class="p-5 md:p-10 border rounded-2xl shadow-xl border-white/30 bg-white/30 backdrop-blur-sm"
            >
              <div class="mb-4 md:mb-0 text-center md:text-right m-4">
                <h2
                  class="uppercase font-poppins text-blue-700 mb-4 font-bold text-2xl drop-shadow-lg"
                >
                  Love <span style="color: black">Numbers</span
                  ><span style="color: grey">_Game</span> Or Get Your Money Back
                  💸
                </h2>
                <p>
                  Our community
                  <span class="italic font-bold">loves</span> Numbers Game, and
                  you will too! <br /><br />
                  But, if for any reason you're not satisfied, we offer a full
                  refund within your first week.
                  <br /><br />
                  No questions asked. Just email
                  <span class="text-blue-700">support@numbersgame.uk</span
                  >.<br /><br />
                </p>
              </div>
              <span class="flex-col md:flex-row gap-1 flex">
                <img
                  class="m-auto shadow-xl md:w-1/3"
                  src="@/assets/Review1.png"
                />
                <img
                  class="m-auto shadow-xl md:w-1/3"
                  src="@/assets/Review2.png"
                />
                <img
                  class="m-auto shadow-xl md:w-1/3"
                  src="@/assets/Review3.png"
                />
              </span>
            </div>
          </section>
        </div>
      </div>
      <div>
        <section class="max-w-6xl mx-auto px-4 py-4 md:py-12 relative">
          <div
            class="p-5 md:p-10 border rounded-2xl shadow-xl border-white/30 bg-white/30 backdrop-blur-sm"
          >
            <div
              class="md:flex flex-row-reverse items-center justify-center gap-10 md:gap-8"
            >
              <div class="flex-1 mb-8 md:mb-0 text-center md:text-left">
                <h2
                  class="uppercase font-poppins text-blue-700 mb-2 font-bold text-2xl drop-shadow-lg"
                >
                  How It Started 👀
                </h2>
                <p class="md:pr-[20%]">
                  This industry is rife with thieving bookies, false promises
                  and dodgy tipsters charging £50 a month 😬<br /><br />
                  We are Olly & Sam, two normal blokes disrupting the football
                  industry by making data more accessible 👋🏻<br /><br />
                  We built Numbers Game for ourselves, but once we found it made
                  our football predicting more fun
                  <span class="italic font-bold">and</span> more successful, we
                  decided we had to share it with our mates 🤝<br /><br />
                </p>
                <span class="flex-col md:flex-row gap-1 flex">
                  <img
                    class="m-auto md:w-1/3 shadow-xl border rounded-2xl aspect-square object-cover"
                    src="https://numbers-game-assets.s3.eu-west-2.amazonaws.com/images/000012760026.jpg"
                  />
                  <img
                    class="m-auto md:w-1/3 shadow-xl border rounded-2xl aspect-square object-cover"
                    src="https://numbers-game-assets.s3.eu-west-2.amazonaws.com/images/000012760031.jpg"
                  />
                  <img
                    class="m-auto md:w-1/3 shadow-xl border rounded-2xl"
                    src="@/assets/whoarewe3.png"
                  />
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div>
        <section class="max-w-6xl mx-auto px-4 relative">
          <div class="p-5 md:p-10">
            <div
              class="md:flex flex-row-reverse items-center justify-center gap-10 md:gap-8"
            >
              <div class="flex-1 md:mb-0 text-center">
                <h2
                  class="uppercase font-poppins text-gray-800 mb-2 font-bold text-3xl drop-shadow-lg sm:pt-4"
                >
                  How It's Going 🔥
                </h2>
                <vee-observe
                  :root="null"
                  :root-margin="'0px'"
                  :threshold="1"
                  :once="true"
                  @on-change="onChange"
                >
                  <div class="flex-1 text-center mb-8 md:mb-0">
                    <h2
                      class="uppercase text-gray-800 font-bold text-[100px] drop-shadow-lg"
                    >
                      {{ animatedNumber }}
                    </h2>
                    <p class="text-lg/6 tracking-tighter text-gray-800">
                      Football matches correctly predicted<br />
                      ...and counting 🚀
                    </p>
                  </div>
                </vee-observe>
                <div class="block space-x-4 mt-10">
                  <div
                    class="flex flex-col inset-0 items-center justify-center relative"
                  >
                    <a
                      href="https://numbersgame.uk/signup/monthly"
                      class="block space-x-4"
                    >
                      <router-link
                        :to="`/signup/${type}`"
                        class="btn-gradient shadow-xl inline-flex items-center justify-center text-xs p-3 px-6 font-bold uppercase lg:text-lg text-white"
                      >
                        Get Started
                      </router-link>
                    </a>
                    <div class="block mt-4">
                      <button
                        class="text-xs uppercase text-brandGrey underline"
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div>
        <div
          class="max-w-6xl p-5 md:p-10 flex flex-col items-center justify-center mx-auto"
        >
          <h2
            class="uppercase font-poppins text-gray-800 mb-2 font-bold text-3xl drop-shadow-lg text-center"
          >
            Discover MatchView™ 🤩
          </h2>
          <p class="text-center text-gray-800 mb-6 mt-4">
            <span class=""
              >Our MatchView™ cards enable our mission:
              <strong>Make Football Data Easy</strong>.<br /><br />
              Each upcoming fixture has it's own MatchView™ card that is
              designed to be simple, glanceable and intuitive, giving you all
              the data you need in an easy to read format.</span
            ><br /><br />
            Find out more below 👇
          </p>
        </div>
        <section class="max-w-6xl mx-auto px-4 py-4 md:py-12 relative">
          <div
            class="md:flex items-center justify-center p-5 md:p-10 gap-10 md:gap-8 border rounded-2xl shadow-xl border-white/30 bg-white/30 backdrop-blur-sm"
          >
            <div class="flex-1 mb-8 md:mb-0">
              <h2
                class="uppercase font-poppins text-blue-700 mb-2 font-bold text-2xl drop-shadow-lg"
              >
                Stop Guessing, Start <br />Predicting 🔮
              </h2>
              <p>
                Our <strong>machine learning algorithms</strong> provide an
                accuracte percentage chance of each possible result, giving you
                a clear view of the most likely outcomes.<br />Use this as a
                quick summary of the underlying data.
              </p>
            </div>
            <div class="blur-type-1" v-in-viewport="{ margin: '-50% 0px' }">
              <Card
                mode="chrono"
                :match="nextMatch"
                :showOdds="true"
                v-if="nextMatch.date"
                class="!w-full md:min-w-[385px]"
              />
            </div>
          </div>
        </section>
      </div>
      <div>
        <section class="max-w-6xl mx-auto px-4 py-4 md:py-12 relative">
          <div
            class="p-5 md:p-10 border rounded-2xl shadow-xl border-white/30 bg-white/30 backdrop-blur-sm"
          >
            <div
              class="md:flex flex-row-reverse items-center justify-center gap-10 md:gap-8"
            >
              <div class="flex-1 mb-8 md:mb-0 md:text-right">
                <h2
                  class="uppercase font-poppins text-blue-700 mb-2 font-bold text-2xl drop-shadow-lg"
                >
                  Predictions & stats, at a glance 👀
                </h2>
                <p>
                  Click
                  <strong><span style="color: #1c4ed8">SEE DATA</span></strong>
                  to view the underlying stats. These dropdowns are designed to
                  allow you to easily find useful data points and profit from
                  them when making picks.
                </p>
                <span class="\">
                  <h2
                    class="uppercase font-poppins text-blue-700 mb-2 font-bold text-2xl drop-shadow-lg mb-5 mt-10 text-center text-left md:text-right"
                  >
                    Make Data-driven decisions in seconds 💪
                  </h2>
                  <span class="mb-5">
                    <div
                      class="flex border p-2 rounded-3xl shadow-xl mb-5"
                      style="height: fit-content; width: fit-content"
                    >
                      <span class="m-auto mx-1.5 text-3xl">🤖</span>
                      <div class="text-left text-sm" style="line-height: 1.2">
                        <p class="p-2">
                          AI Powered Predictions for Both Teams To Score, Most
                          Likely Scoreline, Goalscorers and more.
                        </p>
                      </div>
                    </div>
                  </span>
                  <span class="mb-5">
                    <div
                      class="flex border p-2 rounded-3xl shadow-xl mb-5"
                      style="height: fit-content; width: fit-content"
                    >
                      <span class="m-auto mx-1.5 text-3xl">📖</span>
                      <div class="text-left text-sm" style="line-height: 1.2">
                        <p class="p-2">
                          Head to Head and recent form data with historical
                          match stats.
                        </p>
                      </div>
                    </div>
                  </span>
                  <span class="mb-5">
                    <div
                      class="flex border p-2 rounded-3xl shadow-xl mb-5"
                      style="height: fit-content; width: fit-content"
                    >
                      <span class="m-auto mx-1.5 text-3xl">📈</span>
                      <div class="text-left text-sm" style="line-height: 1.2">
                        <p class="p-2">
                          Detailed player and team stats with colour coded bars
                          for easy comparison.
                        </p>
                      </div>
                    </div>
                  </span>
                  <span class="mb-5">
                    <div
                      class="flex border p-2 rounded-3xl shadow-xl mb-5"
                      style="height: fit-content; width: fit-content"
                    >
                      <span class="m-auto mx-1.5 text-3xl">🌏</span>
                      <div class="text-left text-sm" style="line-height: 1.2">
                        <p class="p-2">
                          MatchView™ cards are generated two weeks in advance
                          for over 50 competitions worldwide.
                        </p>
                      </div>
                    </div>
                  </span>
                </span>
              </div>
              <div class="blur-type-3" v-in-viewport="{ margin: '-50% 0px' }">
                <Card
                  mode="chrono"
                  :match="nextMatch"
                  :showOdds="true"
                  v-if="nextMatch.date"
                  class="!w-full md:min-w-[385px] relative"
                  :extraBlurContent="true"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <div>
        <div class="">
          <section class="max-w-6xl mx-auto px-4 py-4 md:py-12 relative">
            <div
              class="md:flex items-center justify-center gap-10 md:gap-8 p-5 md:p-10 border rounded-2xl shadow-xl border-white/30 bg-white/30 backdrop-blur-sm"
            >
              <div class="flex-1 mb-8 md:mb-0">
                <h2
                  class="uppercase font-poppins text-blue-700 mb-2 font-bold text-2xl drop-shadow-lg"
                >
                  Bang For Your Buck 💸
                </h2>
                <p>
                  Compare our "fair odds" of an outcome with those of the
                  highstreet bookmakers - good odds are highlighted
                  <strong><span style="color: #46d39a">green</span></strong
                  >, allowing you to spot <strong>high value</strong> picks with
                  ease.
                </p>
              </div>
              <div class="blur-type-2" v-in-viewport="{ margin: '-50% 0px' }">
                <Card
                  mode="chrono"
                  :match="nextMatch"
                  :showOdds="true"
                  v-if="nextMatch.date"
                  class="!w-full md:min-w-[385px]"
                />
              </div>
            </div>
          </section>
        </div>
        <div>
          <div class="">
            <section
              class="mx-auto px-4 py-20 relative"
              style="max-width: 60rem"
            >
              <h2
                class="uppercase font-poppins text-gray-800 mb-2 text-center font-bold text-3xl drop-shadow-lg mt-4"
              >
                JOIN 60K+ PEOPLE MAKING BETTER PICKS TODAY 🚀
              </h2>
              <div
                class="flex flex-col inset-0 items-center justify-center relative py-2"
              >
                <div class="block space-x-4">
                  <router-link
                    :to="`/signup/${type}`"
                    class="btn-gradient inline-flex items-center justify-center p-3 px-6 font-bold uppercase text-lg text-white"
                  >
                    Sign Me Up
                  </router-link>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="max-w-lg mx-auto p-4 pb-16 pt-10 relative">
        <div class="max-w-sm mx-auto">
          <h2
            class="uppercase font-poppins text-blue-700 mb-2 font-bold text-2xl drop-shadow-lg"
          >
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <!-- <AISearch @initAIQuestion="initAIQuestion" class="mt-6"></AISearch> -->
        </div>
        <div class="mt-10 flex flex-col gap-4">
          <FAQItem
            v-for="(FAQItem, key) in FAQData"
            :title="FAQItem.title"
            :content="FAQItem.content"
            :key="key"
          >
          </FAQItem>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="my-16 flex items-center justify-center">
        <Loader></Loader>
      </div>
    </template>
  </div>
</template>
<script>
// import Arrow from "@/assets/icons/Arrow";
import Card from "@/components/Card";
import Loader from "@/components/Loader";
// import LeagueList from "@/components/LeagueList";
// import InstagramPost from "@/components/InstagramPost";
import VeeObserve from "vee-observe";
import FAQItem from "@/components/FAQItem.vue";
import FAQData from "../data/FAQs";

import dayjs from "dayjs";
var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);
import gsap from "gsap";

export default {
  name: "Intro",
  props: ["nextMatch", "nextMatchTime", "totalCorrectMatches"],
  components: {
    // Arrow,
    Card,
    Loader,
    // LeagueList,
    VeeObserve,
    // InstagramPost,
    FAQItem,
  },

  data() {
    return {
      type: "monthly",
      scrolling: false,
      countdown: false,
      countdownInterval: false,
      number: 0,
      tweenedNumber: 0,
      AIQuestions: [],
      latestResponse: false,
      showAIOverlay: false,
      gettingResult: false,
      overrideQuestion: "",
      FAQData: [],
      AIResultsShort: true,
    };
  },
  computed: {
    backgroundStyle() {
      return {
        background: "#ffffff",
        backgroundImage:
          "radial-gradient(at 20% 30%, rgba(0, 0, 238, 0.37) 0px, transparent 50%), radial-gradient(at 80% 20%, rgba(0, 0, 238, 0.25) 0px, transparent 50%), radial-gradient(at 60% 80%, rgba(120, 120, 238, 0.3) 0px, transparent 50%), radial-gradient(at 90% 70%, rgba(200, 200, 220, 0.4) 0px, transparent 50%), radial-gradient(at 10% 90%, rgba(0, 0, 238, 0.2) 0px, transparent 50%)",
      };
    },
    animatedNumber: function () {
      return this.tweenedNumber.toFixed(0);
    },
  },
  methods: {
    toggleLogin() {
      document.getElementById("loginbutton").click();
    },
    onChange(entry) {
      if (entry.isIntersecting) {
        this.number = this.totalCorrectMatches;
      }
    },
    pad(num) {
      return num > 9 ? num : "0" + num;
    },
    generateCountdown() {
      let remaining =
        dayjs(this.nextMatchTime * 1000).valueOf() - dayjs().valueOf();

      let days = Math.floor(remaining / (1000 * 60 * 60 * 24)),
        hours = Math.floor(remaining / (1000 * 60 * 60)),
        mins = Math.floor(remaining / (1000 * 60)),
        secs = Math.floor(remaining / 1000),
        dd = days,
        hh = hours - days * 24,
        mm = mins - hours * 60,
        ss = secs - mins * 60;

      const returnString = `${this.pad(dd)}:${this.pad(hh)}:${this.pad(
        mm
      )}:${this.pad(ss)}`;
      this.countdown = returnString;
    },
    toggleOnly5(payload) {
      this[payload] = !this[payload];
    },
    hideAIOverlay() {
      this.showAIOverlay = false;
      this.AIQuestions = [];
    },
  },
  watch: {
    number: function (newValue) {
      gsap.to(this.$data, { duration: 0.5, tweenedNumber: newValue });
    },
    nextMatchTime() {
      if (this.nextMatchTime) {
        this.countdownInterval = setInterval(() => {
          this.generateCountdown();
        }, 1000);
      }
    },
    countdown() {
      if (
        this.countdown == "00:00:00:00" ||
        this.countdown.charAt(0) == "-" ||
        this.countdown.charAt(1) == "-"
      ) {
        clearInterval(this.countdownInterval);
        this.countdown = "Now!";
        return;
      }
    },
  },
  mounted() {
    this.$refs.video ? this.$refs.video.pause() : false;
    this.FAQData = FAQData;

    // Listen for scroll events
    window.addEventListener(
      "scroll",
      () => {
        // Clear our timeout throughout the scroll
        window.clearTimeout(this.scrolling);
        this.$refs.video ? this.$refs.video.play() : false;

        // Set a timeout to run after scrolling ends
        this.scrolling = setTimeout(() => {
          // Run the callback
          this.$refs.video ? this.$refs.video.pause() : false;
          console.log("Scrolling has stopped.");
        }, 66);
      },
      false
    );
    var text = document.getElementById("typewriter-header");

    // Glitch text effect - RGB split style
    const words = ["Smarter", "Faster"];
    let currentIndex = 0;

    const cycleWord = () => {
      const nextWord = words[currentIndex];
      text.innerText = nextWord;
      text.setAttribute("data-text", nextWord);

      // Trigger glitch animation
      text.classList.remove("glitching");
      void text.offsetWidth; // Force reflow
      text.classList.add("glitching");

      currentIndex = (currentIndex + 1) % words.length;
      setTimeout(cycleWord, 2500);
    };

    // Initialize
    text.innerText = words[0];
    text.setAttribute("data-text", words[0]);
    setTimeout(cycleWord, 2500);
  },
};
</script>
<style scoped>
.flip-digit-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flip-digit {
  background-color: rgb(12, 12, 12);
  background-image:
    repeating-linear-gradient(
      0deg,
      #000000 0px,
      #000000 1px,
      transparent 1px,
      transparent 3px
    ),
    repeating-linear-gradient(
      90deg,
      #000000 0px,
      #000000 1px,
      transparent 1px,
      transparent 3px
    );
  border-radius: 8px;
  padding: 12px 10px;
  position: relative;
  min-width: 40px;
  box-shadow:
    inset 0 0 20px rgba(0, 0, 0, 0.8),
    0 2px 8px rgba(0, 0, 0, 0.5);
}

.flip-digit::after {
  display: none;
}

.digit-top {
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  font-family: "unibody-8-new", sans-serif;
  text-shadow:
    0 0 4px rgba(255, 255, 255, 0.5),
    0 0 8px rgba(255, 255, 255, 0.3),
    0 0 16px rgba(255, 255, 255, 0.2);
  display: block;
  line-height: 1;
  letter-spacing: 2px;
  filter: blur(0.4px);
}

.flip-separator {
  color: #4b5563;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding: 0 3px;
  margin-top: -16px;
  text-shadow:
    0 0 8px rgba(255, 255, 255, 0.8),
    0 0 16px rgba(255, 255, 255, 0.6);
  filter: blur(0.5px);
}

/* Scoreboard panel for "Match Started" */
.scoreboard-panel {
  background-color: rgb(12, 12, 12);
  background-image:
    repeating-linear-gradient(
      0deg,
      #000000 0px,
      #000000 1px,
      transparent 1px,
      transparent 3px
    ),
    repeating-linear-gradient(
      90deg,
      #000000 0px,
      #000000 1px,
      transparent 1px,
      transparent 3px
    );
  border-radius: 8px;
  padding: 12px 20px;
  box-shadow:
    inset 0 0 20px rgba(0, 0, 0, 0.8),
    0 2px 8px rgba(0, 0, 0, 0.5);
  display: inline-block;
}

.scoreboard-text {
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  font-family: "unibody-8-new", sans-serif;
  text-shadow:
    0 0 4px rgba(255, 255, 255, 0.8),
    0 0 8px rgba(255, 255, 255, 0.5),
    0 0 16px rgba(255, 255, 255, 0.3);
  display: block;
  line-height: 1;
  letter-spacing: 2px;
  filter: blur(0.4px);
}

/* Animated Gradient Glow for AI */
.ai-glow {
  display: inline-block;
  background: linear-gradient(90deg, #1966ff, #5036ff, #1554ff, #402fff);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: gradient-shift 3s ease-in-out infinite;
  filter: drop-shadow(0 0 8px rgba(29, 78, 216, 0.2))
    drop-shadow(0 0 20px rgba(124, 58, 237, 0.1));
}

@keyframes gradient-shift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* Gradient Button */
.btn-gradient {
  background: linear-gradient(90deg, #1966ff, #5036ff, #1554ff, #402fff);
  background-size: 300% 100%;
  animation: gradient-shift 3s ease-in-out infinite;
  border: none;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.btn-gradient:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 25px rgba(25, 102, 255, 0.4),
    0 4px 15px rgba(80, 54, 255, 0.3);
}

/* RGB Split Glitch Effect */
.glitch-text {
  position: relative;
  display: inline-block;
  color: #1f2937;
}

.glitch-text::before,
.glitch-text::after {
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.glitch-text::before {
  color: #00ffff;
  z-index: -1;
}

.glitch-text::after {
  color: #ff0040;
  z-index: -1;
}

.glitch-text.glitching::before {
  animation: glitch-cyan 0.4s ease-out;
}

.glitch-text.glitching::after {
  animation: glitch-red 0.4s ease-out;
}

@keyframes glitch-cyan {
  0% {
    opacity: 0.8;
    transform: translate(-8px, -3px);
    clip-path: inset(20% 0 30% 0);
  }
  20% {
    opacity: 0.8;
    transform: translate(5px, 2px);
    clip-path: inset(50% 0 20% 0);
  }
  40% {
    opacity: 0.6;
    transform: translate(-4px, -1px);
    clip-path: inset(10% 0 60% 0);
  }
  60% {
    opacity: 0.4;
    transform: translate(3px, 1px);
    clip-path: inset(40% 0 10% 0);
  }
  80% {
    opacity: 0.2;
    transform: translate(-2px, 0);
    clip-path: inset(0);
  }
  100% {
    opacity: 0;
    transform: translate(0);
  }
}

@keyframes glitch-red {
  0% {
    opacity: 0.8;
    transform: translate(8px, 3px);
    clip-path: inset(40% 0 20% 0);
  }
  20% {
    opacity: 0.8;
    transform: translate(-6px, -2px);
    clip-path: inset(10% 0 50% 0);
  }
  40% {
    opacity: 0.6;
    transform: translate(4px, 1px);
    clip-path: inset(60% 0 10% 0);
  }
  60% {
    opacity: 0.4;
    transform: translate(-3px, -1px);
    clip-path: inset(20% 0 40% 0);
  }
  80% {
    opacity: 0.2;
    transform: translate(2px, 0);
    clip-path: inset(0);
  }
  100% {
    opacity: 0;
    transform: translate(0);
  }
}

/* Page wrapper with unified background */
.page-wrapper {
  min-height: 100vh;
}

/* Glass Cubes Container */
.cubes-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

/* Cube wrapper with perspective */
.cube-wrapper {
  position: absolute;
  --size: 80px;
  perspective: 1500px;
  width: var(--size);
  height: var(--size);
}

/* The 3D cube */
.cube {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  animation: cube-rotate 25s linear infinite;
}

/* Each face */
.face {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(100, 150, 255, 0.4);
  backface-visibility: visible;
  opacity: 0.7;
}

.grid-lines {
  --s: 80px; /* control the size of the grid */
  --n: 10; /* control the granularity */
  --t: 2px; /* the thickness */
  --g: 10px; /* the gap between dashes */

  --c: rgba(85, 98, 112, 0.05) 25%, #0000 0;
  background:
    conic-gradient(at var(--g) var(--t), var(--c))
      calc((var(--s) / var(--n) - var(--g) + var(--t)) / 2) 0 /
      calc(var(--s) / var(--n)) var(--s),
    conic-gradient(from 180deg at var(--t) var(--g), var(--c)) 0
      calc((var(--s) / var(--n) - var(--g) + var(--t)) / 2) / var(--s)
      calc(var(--s) / var(--n));
}

/* Face colors - glass effect with gradients */
.face.front {
  background: linear-gradient(
    135deg,
    rgba(100, 150, 255, 0.3) 0%,
    rgba(150, 100, 220, 0.2) 100%
  );
  transform: translateZ(calc(var(--size) / 2));
}
.face.back {
  background: linear-gradient(
    135deg,
    rgba(80, 130, 220, 0.25) 0%,
    rgba(120, 80, 200, 0.15) 100%
  );
  transform: rotateY(180deg) translateZ(calc(var(--size) / 2));
}
.face.right {
  background: linear-gradient(
    135deg,
    rgba(120, 160, 255, 0.35) 0%,
    rgba(180, 120, 240, 0.2) 100%
  );
  transform: rotateY(90deg) translateZ(calc(var(--size) / 2));
}
.face.left {
  background: linear-gradient(
    135deg,
    rgba(60, 110, 200, 0.25) 0%,
    rgba(100, 70, 180, 0.15) 100%
  );
  transform: rotateY(-90deg) translateZ(calc(var(--size) / 2));
}
.face.top {
  background: linear-gradient(
    135deg,
    rgba(150, 190, 255, 0.4) 0%,
    rgba(200, 150, 255, 0.25) 100%
  );
  transform: rotateX(90deg) translateZ(calc(var(--size) / 2));
}
.face.bottom {
  background: linear-gradient(
    135deg,
    rgba(50, 90, 180, 0.2) 0%,
    rgba(80, 50, 150, 0.1) 100%
  );
  transform: rotateX(-90deg) translateZ(calc(var(--size) / 2));
}

/* Cube positions and sizes */
.cube-1 {
  top: 3%;
  left: 2%;
  --size: 120px;
}
.cube-2 {
  top: 12%;
  right: 6%;
  --size: 90px;
}
.cube-3 {
  top: 50%;
  left: 4%;
  --size: 70px;
}
.cube-4 {
  top: 48%;
  right: 5%;
  --size: 140px;
}
.cube-5 {
  top: 80%;
  left: 6%;
  --size: 100px;
}
.cube-6 {
  top: 30%;
  left: 48%;
  --size: 50px;
}

/* Different rotation speeds and directions */
.cube-1 .cube {
  animation-duration: 30s;
}
.cube-2 .cube {
  animation-duration: 25s;
  animation-direction: reverse;
}
.cube-3 .cube {
  animation-duration: 35s;
}
.cube-4 .cube {
  animation-duration: 28s;
  animation-direction: reverse;
}
.cube-5 .cube {
  animation-duration: 32s;
}
.cube-6 .cube {
  animation-duration: 22s;
  animation-direction: reverse;
}

/* Floating animation on wrapper */
.cube-wrapper {
  animation: cube-float 20s ease-in-out infinite;
}
.cube-1 {
  animation-delay: 0s;
}
.cube-2 {
  animation-delay: -4s;
}
.cube-3 {
  animation-delay: -8s;
}
.cube-4 {
  animation-delay: -12s;
}
.cube-5 {
  animation-delay: -16s;
}
.cube-6 {
  animation-delay: -10s;
}

@keyframes cube-rotate {
  0% {
    transform: rotateX(-20deg) rotateY(0deg);
  }
  100% {
    transform: rotateX(-20deg) rotateY(360deg);
  }
}

@keyframes cube-float {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-30px);
    opacity: 0.8;
  }
}

/* Page load animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in-up {
  animation: fadeInUp 0.8s ease-out forwards;
}

/* Vue transition for right side */
.fade-up-enter-active {
  animation: fadeInUp 0.6s ease-out;
}

.fade-up-leave-active {
  animation: fadeInUp 0.4s ease-in reverse;
}

.delay-200 {
  animation-delay: 0.2s;
  opacity: 0;
}

.delay-400 {
  animation-delay: 0.4s;
  opacity: 0;
}

.delay-600 {
  animation-delay: 0.6s;
  opacity: 0;
}
</style>
